import React, { useState } from "react";
import Question1 from "./Question1";
import Question1_5 from "./Question1_5";
import Question2 from "./Question2";
import Question3 from "./Question3";
import Question4 from "./Question4";
import Question5 from "./Question5";
import Question6 from "./Question6";

import Output from "../Output";
import Question7 from "./Question7";
import Question8 from "./Question8";
import Question9 from "./Question9";
import Question10 from "./Question10";
import Question11 from "./Question11";
import Question12 from "./Question12";
import Question13 from "./Question13";

const Questions = () => {
  const [step, setStep] = useState(1);
  const [answer1, setAnswer1] = useState("");
  const [answer1_5, setAnswer1_5] = useState("");
  const [answer2, setAnswer2] = useState("");
  const [answer3, setAnswer3] = useState("");
  const [answer4, setAnswer4] = useState("");
  const [answer5, setAnswer5] = useState("");
  const [answer6_13_points, setAnswer6_13_points] = useState(0);
  const addStep = () => {
    setStep(step + 1);
  };
  const deleteStep = () => {
    setStep(step - 1);
  };
  const pointsHandler = (pt) => {
    setAnswer6_13_points((prev) => prev + pt);
  };
  switch (step) {
    case 1:
      return <Question1 setAnswer1={setAnswer1} addStep={addStep} />;
    case 2:
      return <Question1_5 deleteStep={deleteStep} setAnswer1_5={setAnswer1_5} addStep={addStep} />;
    case 3:
      return <Question2 deleteStep={deleteStep} setAnswer2={setAnswer2} addStep={addStep} />;
    case 4:
      return <Question3 deleteStep={deleteStep} setAnswer3={setAnswer3} addStep={addStep} />;
    case 5:
      return (
        <Question4
          setAnswer4={setAnswer4}
          addStep={addStep}
          answer1_5={answer1_5}
          answer2={answer2}
          answer3={answer3}
          deleteStep={deleteStep}
        />
      );
    case 6:
      return <Question5 deleteStep={deleteStep} setAnswer5={setAnswer5} addStep={addStep} />;
    case 7:
      return <Question6 deleteStep={deleteStep} pointsHandler={pointsHandler} addStep={addStep} />;
    case 8:
      return <Question7 deleteStep={deleteStep} pointsHandler={pointsHandler} addStep={addStep} />;
    case 9:
      return <Question8 deleteStep={deleteStep} pointsHandler={pointsHandler} addStep={addStep} />;
    case 10:
      return <Question9 deleteStep={deleteStep} pointsHandler={pointsHandler} addStep={addStep} />;
    case 11:
      return <Question10 deleteStep={deleteStep} pointsHandler={pointsHandler} addStep={addStep} />;
    case 12:
      return <Question11 deleteStep={deleteStep} pointsHandler={pointsHandler} addStep={addStep} />;
    case 13:
      return <Question12 deleteStep={deleteStep} pointsHandler={pointsHandler} addStep={addStep} />;
    case 14:
      return (
        <Question13 deleteStep={deleteStep} answer6_13_points={answer6_13_points} answer1_5={answer1_5} addStep={addStep} />
      );
    case 15:
      return (
        <Output deleteStep={deleteStep} answer1_5={answer1_5} addStep={addStep}/>
      );
        
    default:
      return <Output  />;
  }
};

export default Questions;
